module.exports = __webpack_public_path__ + "img/welcome-banner.3b45a14b.jpg";